module.exports = __webpack_public_path__ + "img/Z71_04.4be095ef.jpg";